import {
  ClearButtonType,
  ClearTagsButton,
} from '@aibees/elephant/feature/search-filters/components/filter-tags/components/clear-tags-button';
import { useFilterValues, useSearchQueryFilter } from '@aibees/elephant/hooks';
import { classnames } from '@aibees/shared/utils';
import { Paper } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { SearchLayoutActionListProps as Props } from './types';

export const SearchLayoutActionList = memo(({ className }: Props) => {
  const { removeAllParams } = useSearchQueryFilter();
  const values = useFilterValues();

  const handleClear = () => {
    removeAllParams();
  };

  return (
    <Paper
      className={classnames('SearchLayoutActionList', className)}
      sx={SX.root}
    >
      {!!values?.length && (
        <ClearTagsButton
          type={ClearButtonType.CHIP}
          text={`Clear All`}
          count={values?.length}
          onClick={handleClear}
        />
      )}
    </Paper>
  );
});

SearchLayoutActionList.displayName = 'SearchLayoutActionList';
